import { render, staticRenderFns } from "./slide-aside.vue?vue&type=template&id=0717ab4b"
import script from "./slide-aside.vue?vue&type=script&lang=js"
export * from "./slide-aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports